/**
 *
 */
export default class User {

  #cid = null;
  #email = null;
  #accountText = null;
  #imageUrl = null;
  // TODO: May need to add all User fields here

  constructor(cid, email, accountText, imageUrl) {
    this.#cid = cid;
    this.#email = email;
    this.#accountText = accountText;
    this.#imageUrl = imageUrl;
  }

  get cid() { return this.#cid; }
  get email() { return this.#email; }
  get accountText() { return this.#accountText; }
  get imageUrl() { return this.#imageUrl; }

  static fromJsonObject(o) {
    if (!o.cid || !o.email) {
      clw("ERROR: Missing required field (cid or email)", o);
      return null;
    }
    const user = new User(o.cid, o.email, (o.display_name || ""), (o.image || null));
    return user;
  }
}
